/**
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React from 'react';
import APIClient from '../../common/APIClient';
import { withApplicationContext, withCustomerSiteContext } from '../../common/HOCs';

export const DeviceInfoContext = React.createContext();
export const DeviceInfoConsumer = DeviceInfoContext.Consumer;

class DeviceInfoProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRows: null,
      devices: null,
      deviceHistory: null,
      logs: null,
      selectedDeviceSerialNumber: null,
      isConfirmDeleteModalOpen: false,
    };
  }

  render() {
    return (
      <DeviceInfoContext.Provider
        value={{
          // state vars
          devices: this.state.devices,
          deviceHistory: this.state.deviceHistory,
          selectedRows: this.state.selectedRows,
          selectedDeviceSerialNumber: this.state.selectedDeviceSerialNumber,
          isConfirmDeleteModalOpen: this.state.isConfirmDeleteModalOpen,

          // api methods
          fetchDevices: this.fetchDevices,
          fetchDeviceHistory: this.fetchDeviceHistory,
          setSelectedRow: this.setSelectedRow,
          getIdToken: this.getIdToken,
          logs: this.state.logs,
          fetchLogs: this.fetchLogs,
          toggleConfirmDeleteModal: this.toggleConfirmDeleteModal,
          deleteSelectedDevices: this.deleteSelectedDevices,
          clearSelectedDevices: this.clearSelectedDevices,
        }}
      >
        {this.props.children}
      </DeviceInfoContext.Provider>
    );
  }

  toggleConfirmDeleteModal = () => {
    this.setState({ isConfirmDeleteModalOpen: !this.state.isConfirmDeleteModalOpen });
  };

  clearSelectedDevices = () => {
    this.setState({ selectedRows: [] });
  };

  deleteSelectedDevices = async () => {
    try {
      let message = '';
      let devices = '';
      let operCount = 0;
      const deviceArray = this.state.selectedRows;
      if (deviceArray.length > 1) {
        deviceArray.forEach(function (device) {
          if (operCount > 0) {
            devices = `${devices},${device.serialNumber}`;
          } else {
            devices = device.serialNumber;
          }
          operCount++;
        });
        message = 'Devices deleted successfully.';
      } else {
        devices = deviceArray[0].serialNumber;
        message = 'Device deleted successfully.';
      }
      const response = await APIClient.deleteDevices(
        devices,
        this.props.appContext.user,
        this.props.custSiteContext.selectedCustomer
      );
      this.setState({
        isConfirmDeleteModalOpen: !this.state.isConfirmDeleteModalOpen,
        selectedRows: [],
      });
      this.props.appContext.setNotification(message, 'success');
    } catch (err) {
      this.setState({
        isConfirmDeleteModalOpen: !this.state.isConfirmDeleteModalOpen,
        selectedRows: [],
      });
      return this.props.appContext.handleError(err);
    }
  };

  fetchDevices = async (signal) => {
    let devices = [];
    try {
      // get the selected customer
      devices = await APIClient.fetchDevices(
        this.props.appContext.user.idToken,
        this.props.custSiteContext.selectedCustomer,
        signal
      );
      devices = devices.response;
    } catch (err) {
      if (err.name !== 'AbortError') {
        this.props.appContext.handleError(err);
        console.error(err);
      }
    }
    this.setState({ devices });
    return devices;
  };

  fetchDeviceHistory = async (serialNumber) => {
    try {
      // get the selected customer
      let deviceHistory = await APIClient.fetchDeviceHistory(
        serialNumber,
        this.props.appContext.user.idToken,
        this.props.custSiteContext.selectedCustomer
      );
      deviceHistory = deviceHistory.response;
      this.setState({ deviceHistory });
      this.setState({ selectedDeviceSerialNumber: serialNumber });
    } catch (err) {
      return this.props.appContext.handleModalError(err);
    }
  };

  fetchLogs = async (serialNumber) => {
    try {
      // get the selected customer
      let logs = await APIClient.fetchLogs(
        this.props.appContext.user.idToken,
        serialNumber,
        this.props.custSiteContext.selectedCustomer
      );
      logs = logs.response;
      this.setState({ logs: logs.LinkedList });
    } catch (err) {
      return this.props.appContext.handleModalError(err);
    }
  };

  getIdToken = () => {
    return this.props.appContext.user.idToken;
  };

  setSelectedRow = (selectedRows) => {
    this.setState({ selectedRows });
  };
}

export default withApplicationContext(withCustomerSiteContext(DeviceInfoProvider));
